<span>
  {{ $safeNavigationMigration(params()?.value) | cronDisplay }}
</span>
